/* eslint react/no-multi-comp: 0, react/prop-types: 0 */
import React from 'react';
import { PrismCode } from 'react-prism';
import Helmet from 'react-helmet';
import TruncateExample from '../examples/Truncate';
const TruncateExampleSource = require('!!raw-loader!../examples/Truncate');
export default class ClearfixPage extends React.Component {
    render() {
        return (<div>
                <Helmet title="Truncate"/>
                <h3>Truncate</h3>
                <p>
                    Easy way how to truncate one line or multiline paragraph, which ends with dots. It's necessary
                    adding class <code className="highlighter-rouge">.text-truncate-multiline</code> and another one{' '}
                    <code className="highlighter-rouge">.text-truncate-multiline-*</code> (* is for options 2-6) for
                    multiline truncate.
                </p>
                <div className="docs-example">
                    <TruncateExample />
                </div>
                <pre>
                    <PrismCode className="language-jsx">{TruncateExampleSource}</PrismCode>
                </pre>
            </div>);
    }
}
